import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  labelInitialValues,
  LabelTabs,
} from 'components/organisms/forms/label/LabelForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiIdentificationCard, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostLabel } from 'services/labels';
import { ILabelForm } from 'services/labels/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateLabel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const createLabel = usePostLabel();

  const mutateOptions = useMutateOptions<ILabelForm>();

  const onCreateLabel = async (
    values: ILabelForm,
    helpers: FormikHelpers<ILabelForm>
  ) => {
    await createLabel.mutateAsync(middleware.label.formToQuery(values), {
      ...mutateOptions(helpers),
      onSuccess: ({ id }) => navigate(`/label/${id}/finances`),
    });
  };

  return (
    <Form.Label
      i18nextPrefix='label'
      initialValues={{
        ...labelInitialValues,
      }}
      onSubmit={onCreateLabel}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate('/label')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiIdentificationCard />} />
        </Button>
      }
      disableTabs={[
        LabelTabs.residenceCertificates,
        LabelTabs.contracts,
        LabelTabs.balance,
        LabelTabs.settlements,
        LabelTabs.reports,
        LabelTabs.advance,
        LabelTabs.statistics,
      ]}
    />
  );
};

export default CreateLabel;
